/**
 * GroupAvatar — renders a persona photo (when available) or initials.
 * Falls back to initials on image load error. Used by List + Notes group heads.
 */
import { useState } from 'react'

interface Props {
  size: number
  photo?: string
  initials?: string
  color?: string
  muted?: boolean
}

export function GroupAvatar({ size, photo, initials, color, muted }: Props) {
  const [failed, setFailed] = useState(false)
  const showPhoto = !!photo && !failed
  const fontSize = Math.max(10, Math.round(size * 0.38))

  if (showPhoto) {
    return (
      <img
        src={photo}
        alt=""
        onError={() => setFailed(true)}
        className="flex-shrink-0 object-cover"
        style={{
          width: size, height: size, borderRadius: '50%',
          border: '1px solid var(--color-border)',
          background: 'var(--color-warm-100)',
        }}
      />
    )
  }

  return (
    <div
      className="inline-flex items-center justify-center flex-shrink-0 font-semibold"
      style={{
        width: size, height: size, borderRadius: '50%',
        background: muted ? 'var(--color-warm-200)' : (color ?? 'var(--color-warm-300)'),
        color: muted ? 'var(--color-fg-muted)' : '#fff',
        fontSize,
      }}
    >
      {initials ?? '·'}
    </div>
  )
}
